import "core-js/modules/esnext.global-this.js";
// src/storage-manager.ts
var STORAGE_KEY = "chakra-ui-color-mode";
function createLocalStorageManager(key) {
  return {
    ssr: false,
    type: "localStorage",
    get: function get(init) {
      if (!(globalThis == null ? void 0 : globalThis.document)) return init;
      var value;
      try {
        value = localStorage.getItem(key) || init;
      } catch (e) {}
      return value || init;
    },
    set: function set(value) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {}
    }
  };
}
var localStorageManager = createLocalStorageManager(STORAGE_KEY);
function parseCookie(cookie, key) {
  var match = cookie.match(new RegExp("(^| )".concat(key, "=([^;]+)")));
  return match == null ? void 0 : match[2];
}
function createCookieStorageManager(key, cookie) {
  return {
    ssr: !!cookie,
    type: "cookie",
    get: function get(init) {
      if (cookie) return parseCookie(cookie, key);
      if (!(globalThis == null ? void 0 : globalThis.document)) return init;
      return parseCookie(document.cookie, key) || init;
    },
    set: function set(value) {
      document.cookie = "".concat(key, "=").concat(value, "; max-age=31536000; path=/");
    }
  };
}
var cookieStorageManager = createCookieStorageManager(STORAGE_KEY);
var cookieStorageManagerSSR = function cookieStorageManagerSSR(cookie) {
  return createCookieStorageManager(STORAGE_KEY, cookie);
};
export { STORAGE_KEY, createLocalStorageManager, localStorageManager, createCookieStorageManager, cookieStorageManager, cookieStorageManagerSSR };